<mat-dialog-content>
  <header class="mb-3 row">
    <div class="buttons-top col-12">
      <button mat-mini-fab class="btn-close-orange" mat-dialog-close type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </header>
  <section class="form-group">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-9 p-0">
          <div class="form-group">
            <div class="col-12">
              <input type="text" class="form-control" formControlName="title" placeholder="Titulo da Notícia" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-12">
              <editor
                apiKey="oy5hgwuqm4nl1jq9mdp7enbys95ke8fnzkzd0g3du5rcsadn"
                class="editor"
                [init]="optionsEditor"
                formControlName="content"
              ></editor>
            </div>
          </div>
          <div class="col-sm-6 theme-form-post">
            <div class="group-radio">
              <label class="mr-1">Salvar como:</label>
              <mat-radio-group aria-label="Salvar como" formControlName="status">
                <mat-radio-button [value]="StatusNewsFeed.PUBLISHED" [checked]="checkStatus(StatusNewsFeed.PUBLISHED)">
                  Publica
                </mat-radio-button>
                <mat-radio-button [value]="StatusNewsFeed.DRAFT" [checked]="checkStatus(StatusNewsFeed.DRAFT)">
                  Racunho
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="col-12 p-0">
            <h3 class="category--title mt-0">Categorias</h3>
            <div class="col-12 categories-col">
              <ng-template [ngIf]="categories && categories.length > 0">
                <label *ngFor="let category of categories" class="d-flex align-items-center label-categories">
                  <div class="checkbox-label">
                    <input
                      type="checkbox"
                      class="form-control checkbox"
                      [checked]="selectedCategories.includes(category.uuid)"
                      (change)="onChangeCategory(category.uuid)"
                      placeholder="Titulo da Notícia"
                    />
                    <span></span>
                  </div>
                  <span>{{ category.name }}</span>
                  <button (click)="archivedCategory(category.uuid)" class="btn-close btn-close--category">
                    <i class="far fa-times-circle"></i>
                  </button>
                </label>
              </ng-template>
              <button *ngIf="!isEditCategory; else addNewCategory" (click)="setEditCategory()" class="button btn-plus">
                <i class="fas fa-plus"></i>
                Adicionar nova categoria
              </button>
              <ng-template #addNewCategory>
                <div class="add-input-container">
                  <div class="label-input">
                    <label class="label-input--label">
                      <input type="text" [(ngModel)]="categoryName" [ngModelOptions]="{standalone: true}" />
                    </label>
                  </div>
                  <button mat-button (click)="addCategory()" class="btn-add">Adicionar</button>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="col-12 p-0">
            <h3 class="tags--title">Tags</h3>
            <div class="col-12 tags-col">
              <div class="tags-container">
                <div *ngFor="let tag of tags" class="tag-content">
                  <input
                    [id]="tag.uuid"
                    type="checkbox"
                    class="form-control checkbox tags-checkbox"
                    [checked]="selectedTags.includes(tag.uuid)"
                    (change)="onChangeTag(tag.uuid)"
                    placeholder="Titulo da Notícia"
                  />
                  <label [for]="tag.uuid" class="d-flex align-items-center">
                    <span>{{ tag.name }}</span>
                    <button (click)="archivedTag(tag.uuid)" class="btn-close btn-close--tag">
                      <i class="fas fa-times"></i>
                    </button>
                  </label>
                </div>
              </div>
              <button *ngIf="!isEditTag; else addNewTag" (click)="setEditTag()" class="button btn-plus">
                <i class="fas fa-plus"></i>
                Adicionar nova tag
              </button>
              <ng-template #addNewTag>
                <div class="add-input-container">
                  <div class="label-input">
                    <label class="label-input--label">
                      <input type="text" [(ngModel)]="tagName" [ngModelOptions]="{standalone: true}" />
                    </label>
                  </div>
                  <button mat-button (click)="addTag()" class="btn-add">Adicionar</button>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="col-12 p-0">
            <h3 class="category--title">Autor</h3>
            <div class="col-12 author-col">
              <div class="label-input">
                <label class="label-input--label">
                  <input type="text" formControlName="author" />
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 p-0">
            <h3 class="category--title">Imagem principal do post</h3>
            <div class="col-12 main-image-col">
              <label
                id="btn-upload"
                class="button btn-upload"
                [ngStyle]="post && post.href ? { paddingRight: '0.6rem' } : { paddingRight: '1rem !important' }"
              >
                Escolha uma imagem
                <input type="file" class="file-upload" (change)="handleUpload($event)" />
                <span *ngIf="post && post.href" class="btn-img-upload-check-icon">
                  <i class="fas fa-check"></i>
                </span>
              </label>
              <span *ngIf="field('file').value" class="btn-new">New</span>
            </div>
            <div class="text-white font-11">Recomendado: width 930 x height 413</div>
          </div>
          <div class="col-12 p-0">
            <h3 class="category--title">Data do post</h3>
            <div class="col-12 post-date-col">
              <div class="label-input">
                <label class="label-input--label">
                  <input type="date" formControlName="created_at" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-content">
        <button type="button" class="btn btn-primary button btn-close--cancel-post" mat-dialog-close>
          <i class="fas fa-times"></i>
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary button btn-save"
          [disabled]="checkField()"
          (click)="post ? updatePost() : save()"
        >
          <i class="fas fa-check"></i>
          Salvar
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>
